import { SEARCH_INSTITUTIONS_SUCCESS } from 'stash/actions/api/bankAccount';

type InstitutionsSearchSuccessAction = {
	type: typeof SEARCH_INSTITUTIONS_SUCCESS;
	response: {
		institutions: unknown[];
	};
};

type InstitutionsSearchAction = InstitutionsSearchSuccessAction | { type: string };

const institutions_search = (
	state: unknown[] = [],
	action: InstitutionsSearchAction
): unknown[] => {
	switch (action.type) {
		case SEARCH_INSTITUTIONS_SUCCESS:
			return (action as InstitutionsSearchSuccessAction).response.institutions;
		default:
			return state;
	}
};

export default institutions_search;
